<div class="body">
  @if (title) {
    <div class="celo-dialog-header">
      <div class="title">{{ title }}</div>
      @if (!hideCloseButton) {
        <button
          mat-icon-button
          class="celo-dialog-close"
          aria-label="Close"
          [mat-dialog-close]="false"
        >
          <i class="material-icons">close</i>
        </button>
      }
    </div>
  } @else if (!hideCloseButton) {
    <button
      mat-icon-button
      class="celo-dialog-close celo-dialog-close--floating"
      aria-label="Close"
      [mat-dialog-close]="false"
    >
      <i class="material-icons">close</i>
    </button>
  }
  <div class="content bodycontent">
    <div>{{ content }}</div>
    @if (payload) {
      <div>
        @for (item of payload; track item) {
          <div class="appear_1">
            @if (item.type === "verifyIdentityInfo") {
              <div>
                <app-verify-identity-info
                  [message]="item.message"
                ></app-verify-identity-info>
              </div>
            }
            @if (item.type === "downloadMobileAppInfo") {
              <div>
                <app-verify-identity-info
                  [message]="item.message"
                ></app-verify-identity-info>
              </div>
            }
            @if (item.type === "badgeInfo") {
              <div>
                <app-badge-info
                  [ownProfile]="item.ownProfile"
                  [userId]="item.userId"
                  [name]="item.name"
                  [name_verified_as]="item.name_verified_as"
                  [title]="item.title"
                  [workspaces]="item.workspaces"
                  [identityVerificationStatus]="item.identityVerificationStatus"
                  [profession]="item.profession"
                  [hasImage]="item.hasImage"
                ></app-badge-info>
              </div>
            }
            @if (item.type === "patientData") {
              <div class="pt-3 pb-3">
                <app-edit-patient
                  [patient]="item.data"
                  [canSave]="false"
                  [editMode]="false"
                  [showConsent]="true"
                  [consent]="item.consent"
                  [alignment]="'horizontal'"
                ></app-edit-patient>
              </div>
            }
            @if (item.type === "text") {
              <div class="subtext celo-text-14 celo-grey">
                <p>{{ item.data }}</p>
              </div>
            }
            @if (item.type === "innerHTML") {
              <div class="subtext celo-text-14">
                <p [innerHtml]="item.data"></p>
              </div>
            }
            @if (item.type === "editField") {
              <div class="subtext">
                <form #form class="pt-3 celo-input-outline">
                  <div>
                    <mat-form-field class="w-100" appearance="outline">
                      <mat-label>{{ item.data.fieldName }}</mat-label>
                      <input
                        autocomplete="off"
                        matInput
                        name="Field"
                        #fieldName
                        required
                        [(ngModel)]="item.data.value"
                        (ngModelChange)="
                          editFieldChange(item.data); result_type = item.type
                        "
                        [attr.maxlength]="
                          item.data.maxlength ? item.data.maxlength : null
                        "
                      />
                    </mat-form-field>
                  </div>
                </form>
              </div>
            }
            @if (item.type === "selectField") {
              <div class="subtext">
                <form #form class="pt-3 celo-input-outline">
                  <div>
                    <mat-form-field class="w-100" appearance="outline">
                      <mat-label>Title (Optional)</mat-label>
                      <mat-select
                        name="title"
                        [(ngModel)]="item.data.value"
                        (ngModelChange)="
                          editFieldChange(item.data); result_type = item.type
                        "
                      >
                        @for (tit of item.options; track tit) {
                          <mat-option value="{{ tit.value }}">{{
                            tit.display
                          }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </form>
              </div>
            }
            @if (item.type === "addCompany") {
              <div class="company_details">
                <app-add-company-details
                  [company]="item.data"
                  [workspace]="item.data"
                  [workspaceId]="item.data.companyId"
                  [department]="item.data.departmentId"
                  [position]="item.data.position"
                  [email]="item.data.email"
                  [companyReadonly]="true"
                  (validity)="company_details_valid = $event"
                  (dataChange)="
                    company_details = $event;
                    result_data = $event;
                    result_type = 'save'
                  "
                ></app-add-company-details>
                <div>
                  <button
                    class="celo-danger-button celo-hoverable"
                    [mat-dialog-close]="{
                      type: 'delete',
                      payload: item.data.companyId,
                      workspace: item.data,
                    }"
                    mat-button
                  >
                    Leave workspace
                  </button>
                </div>
              </div>
            }
            @if (item.type === "removedWorkspace") {
              <div class="workspace_removed">
                <img
                  src="../../../assets/empty_states/workspace-remove.svg"
                  alt=""
                />
                <div class="title">Your workspace has been removed</div>
                <div class="subtitle">
                  You can still log in to your Celo account using the following
                  email address(s) and your existing password
                </div>
                @if (item.emails) {
                  <div class="emails">
                    @for (email of item.emails; track email) {
                      <div>
                        <div class="email">{{ email }}</div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (item.type === "celoSnackbar") {
              <div class="workspace_removed">
                <div class="title-line">
                  @if (item.icon) {
                    <div class="icon">
                      <mat-icon [svgIcon]="item.icon"></mat-icon>
                    </div>
                  }
                  @if (item.title) {
                    <span class="title">
                      {{ item.title }}
                    </span>
                  }
                </div>
                @if (item.text) {
                  <div class="subtext celo-text-14 celo-grey celo-text-centred">
                    <p>{{ item.text }}</p>
                  </div>
                }
              </div>
            }
            @if (item.type === "email_invite") {
              <div class="workspace_removed">
                <app-emailer
                  [type]="item.invite_type"
                  [link]="item.link"
                  [id]="item.id"
                  (completed)="close()"
                  [payload]="item.payload"
                  [workspace_name]="item.workspace_name"
                ></app-emailer>
              </div>
            }
            @if (item.type === "updateEmail") {
              <div class="vertical">
                <div>&nbsp;</div>
                <button
                  [disabled]="disabled"
                  [mat-dialog-close]="{ type: 'update_and_leave' }"
                  mat-button
                  class="celo-primary-button uppercase"
                >
                  update and leave
                </button>
                <button
                  [disabled]="disabled"
                  [mat-dialog-close]="{ type: 'leave' }"
                  mat-button
                  class="celo-secondary-button uppercase"
                >
                  leave without updating
                </button>
                <button
                  [mat-dialog-close]="false"
                  mat-button
                  class="celo-secondary-button uppercase"
                >
                  cancel
                </button>
              </div>
            }
            @if (item.type === "addProfession") {
              <div class="company_details">
                <app-edit-profession
                  [status]="item.status"
                  [myCategory]="item.myCategory"
                  [myProfession]="item.myProfession"
                  [professionReadonly]="item.status === 'Pending'"
                  (dataChange)="result_data = $event"
                  (validity)="disabled = !$event"
                  (confirmButtonTextChange)="confirmButtonText = $event"
                  (verifyProfession)="verifyProfession($event)"
                ></app-edit-profession>
              </div>
            }
            @if (item.type === "editProfession") {
              <div class="company_details">
                <app-edit-profession
                  [status]="item.status"
                  [editMode]="true"
                  [myCategory]="item.myCategory"
                  [myProfession]="item.myProfession"
                  [professionReadonly]="true"
                  (dataChange)="result_data = $event"
                  (validity)="disabled = !$event"
                  (verifyProfession)="verifyProfession($event)"
                  (removeProfession)="removeProfession($event)"
                ></app-edit-profession>
              </div>
            }
            @if (item.type === "verifyProfession") {
              <div class="company_details">
                <app-verify-profession
                  [countryCode]="item.countryCode"
                  [myCategory]="item.myCategory"
                  [myProfession]="item.myProfession"
                  (dataChange)="result_data = $event"
                  (validity)="disabled = !$event"
                  (verifyLater)="verifyLater($event)"
                ></app-verify-profession>
              </div>
            }
            @if (item.type === "verifyProfessionSuccess") {
              <div class="company_details">
                <app-verify-profession-success></app-verify-profession-success>
              </div>
            }
            @if (item.type === "registerWorkspace") {
              <div class="company_details">
                <app-register-company
                  [workEmail]="item.email"
                  (validity)="disabled = !$event"
                  (dataChange)="result_data = $event"
                ></app-register-company>
              </div>
            }
            @if (item.type === "registerWorkspaceSuccess") {
              <div class="company_details">
                <app-register-company-success
                  [hideLogo]="true"
                ></app-register-company-success>
              </div>
            }
            @if (item.type === "shareMyProfile") {
              <div>
                <app-profile-share></app-profile-share>
              </div>
            }
            @if (item.type === "home_cta") {
              <div class="company_details cta">
                <div class="title">{{ item.data.title }}</div>
                @for (step of item.data.steps; track step; let index = $index) {
                  <div class="step celo-hoverable-dark">
                    <img [src]="step.image" alt="" />
                    <div class="texts">
                      <div class="subtitle">{{ step.title }}</div>
                      <div class="subdescription">{{ step.description }}</div>
                      @if (step.button) {
                        <button
                          [id]="step.id"
                          [mat-dialog-close]="{ type: step.id }"
                          (click)="(step.action)"
                          mat-button
                          class="celo-primary-button uppercase"
                        >
                          {{ step.button }}
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if (item.type === "integrations") {
              <div class="mt-4 mb-3 celo-input-outline">
                <div class="subtitle">
                  Select where you want to export the photo
                </div>
                <app-integrations-picker
                  (selectionChange)="
                    result_data = $event;
                    result_type = 'integrations';
                    disabled =
                      !result_data.integrationId ||
                      !result_data.services ||
                      (result_data.services.length !== 0 &&
                        !result_data.serviceCode)
                  "
                  [integrations]="item['integrations']"
                  [exportableTo]="item['exportableTo']"
                  [consent]="item.consent"
                ></app-integrations-picker>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <div
    class="action"
    [ngClass]="{
      vertical: alignment === 'vertical',
      horizontal: alignment !== 'vertical',
    }"
  >
    @if (!confirmOnly && cancelButtonText) {
      <button
        [mat-dialog-close]="false"
        mat-button
        class="celo-secondary-button uppercase"
      >
        {{ cancelButtonText }}
      </button>
    }
    @if (confirmButtonText) {
      <button
        [disabled]="disabled"
        (click)="submit()"
        mat-button
        class="celo-primary-button uppercase"
      >
        {{ confirmButtonText }}
      </button>
    }
  </div>
</div>
